import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Home from '../../pages/home/home';
import SelfPaced from '../../pages/assessments/self-paced';
import WmAssessment from '../../pages/assessments/working-memory/wm-assessment';
import CandidateReportLink from '../../pages/reports/candidate-report-link';

function AssessmentRoutes() {
  return (
    <Routes>
      <Route path="/*" element={<Home displayAssessments={true} />} />
      <Route path="assessments/work-preferences" element={<SelfPaced type="work-preferences" time="20" />} />
      <Route path="/assessments/acumen" element={<WmAssessment />} />
      <Route path="/assessments/competencies" element={<SelfPaced type="competencies" time="7" />} />
      <Route path="/client/:slug/reports-by-token/:token" element={<CandidateReportLink />} />
      <Route
        path="/assessments/competencies/rater/:raterIndex"
        element={<SelfPaced type="rater-competencies" time="4-7" />}
      />
    </Routes>
  );
}

export default AssessmentRoutes;
